export const initData = (innerHTML) => {
    const checkExistHTML = () => innerHTML ? (innerHTML !== '' || innerHTML !== '<p><br></p>') ? true : false : false

    return checkExistHTML() ? `<div contenteditable="false">${innerHTML}</div>` : ''
}

export const clearEditable = (html) => {
    if (!html) return null;

    const cleaned = html
        .replace(
            /<div[^>]*contenteditable\s*=\s*["']false["'][^>]*>/gi,
            ''
        )
        .replace(/<\/div>\s*$/gi, '')
        .trim();

    /**
     * Detect empty editor states
     */
    const isEmpty =
        !cleaned ||
        cleaned === '<p><br></p>' ||
        cleaned === '<p><br /></p>' ||
        cleaned.replace(/<[^>]*>/g, '').trim() === '';

    return isEmpty ? null : cleaned;
};